import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import { ErrorBlock } from '@/components/ErrorBlock'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'

export interface NewPaymentMethodDialogProps {
  showing: boolean
  isDisabled: boolean
  onClose: () => unknown
  isSavePending: boolean
  onSave: () => unknown
  saveError?: unknown
  onDismissSaveError: () => unknown
  children?: ReactNode
}

export function NewPaymentMethodDialog({
  showing,
  isDisabled,
  onClose,
  isSavePending,
  onSave,
  saveError,
  onDismissSaveError,
  children,
}: NewPaymentMethodDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSavePending ? undefined : onClose}
    >
      <>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>{children}</ModalSheetContent>
        {!!saveError && (
          <ErrorBlock
            tackOn="bottom"
            error={saveError}
            onClose={onDismissSaveError}
          />
        )}

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button
              label="Cancel"
              onPress={onClose}
              isDisabled={isSavePending}
            />
            <Button
              label="Save"
              variant="primary"
              isDisabled={isDisabled}
              isPending={isSavePending}
              onPress={onSave}
              testId="add-payment-method-modal-save-button"
            />
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </>
    </ModalSheet>
  )
}
